export const QUIZ_IDS = Object.freeze({
  default: 'default', // onboarding-1
  ceo: 'ceo',
})